import Recipes from './Recipes';

export const recipesRoutes = [{path: '/recipes', name: 'Recipes', Component: Recipes}];
